<template>
  <div id="footer">
    <p>
      Made with 💖 by
      <a href="https://commithub.com" target="_blank" rel="noopener">
        CommitHub
      </a>
    </p>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style lang="scss">
#footer {
  margin: 3rem;
  text-align: center;
}
</style>
